import styles from '../styles/components/channelList.module.css';

import { ReactComponent as ChannelIcon } from "../assets/channel.svg";
import { ReactComponent as MoneyIcon } from "../assets/money.svg";
import { ReactComponent as ArrowIcon } from "../assets/components/channel_list/arrow.svg";
import { ReactComponent as ApproveIcon } from "../assets/pages/moderation/approve.svg";
import { ReactComponent as DeclineIcon } from "../assets/pages/moderation/decline.svg";
import { ReactComponent as ListIcon } from "../assets/components/nav/subList.svg";
import { Chat } from '../models/chat';
import { MyOrder, Order } from '../models/order';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import config from '../config';
import Spinner from './Spinner';


interface ComponentProps {
    bottomButtons?: {[key: string]: () => void} | null;
    // bottomButtonCallback?: Function | null; 
    handleChannelButton?: Function | null;
    handleChannelClick?: Function | null;
    scrollBottomCallback?: Function | null;
    loading?: boolean | null;
    mode: 'orders' | 'myOrders' | 'chats' | 'selectChat' | 'selectChatList' | 'moderation' | 'adminChat';
    list: Chat[] | Order[] | MyOrder[];
    nullMessage?: string | null;
    inline?: boolean;
    processButtons?: string[];
    paddingBottom?: boolean;
    loadingDescription?: boolean;
    methodInfoCallback?: (() => void) | null;
};


export default function ChannelList({
    bottomButtons = null, 
    handleChannelButton = null, 
    handleChannelClick = null, 
    mode, 
    list, 
    nullMessage = null, 
    scrollBottomCallback = null, 
    inline = false,
    processButtons = [],
    paddingBottom = true,
    loading = false,
    loadingDescription = false,
    methodInfoCallback = null
}: ComponentProps) {
    const [channelNum, setChannelNum] = useState(0);
    const [openedOrderID, setOpenedOrderID] = useState<number | null>(null);
    const bodyRef = useRef<HTMLDivElement>(null);

    const handleScroll = () => {
        if (scrollBottomCallback === null || list.length === channelNum || (list.length > 0 && list.length < 10)) {
            return;
        };

        const container = bodyRef.current;
        if (container) {
          const { scrollTop, scrollHeight, clientHeight } = container;
    
          const atBottom = scrollTop + clientHeight >= scrollHeight - 30;
          if (atBottom) {
            setChannelNum(list.length);
            scrollBottomCallback();
          };
        };
    };

    useEffect(() => {
        if (bodyRef.current && (bodyRef.current.scrollHeight <= bodyRef.current.clientHeight)) {
            handleScroll();
        };
    }, [list.length]);

    const getChatPhoto = (chatName: string, photo_url: string, clickCallBack: Function) => {
        if (photo_url)
            return <img src={photo_url.startsWith("https://") ? photo_url : config.s3Url + photo_url} className={styles.channel_logo} onClick={(e) => clickCallBack(e)} loading='lazy'/>
        else
            return <div className={styles.channel_logo} onClick={(e) => clickCallBack(e)}><span>{chatName[0]}</span></div>;
    };

    return <div className={styles.list_wrapper}>
        <div className={styles.channels_list} onScroll={handleScroll} ref={bodyRef} style={paddingBottom === false ? {paddingBottom: 0} : (inline ? {paddingBottom: 0, flex: "none"} : {})}>
            {methodInfoCallback && mode === "orders" && <div className={styles.channel} key="list_pr_method" onClick={methodInfoCallback} style={{borderBottom: "solid 0.1px var(--tg-theme-section-separator-color)"}}>
                <div className={styles.system_logo} onClick={(e) => {e.stopPropagation(); methodInfoCallback();}}><ListIcon/></div>
                <div className={`${styles.channel_body} ${styles.channel__without_border}`} onClick={(e) => {e.stopPropagation(); methodInfoCallback();}} style={{borderBottom: "none"}}>
                    <div className={styles.channel_data}>
                        <span className={styles.channel_name}>Реклама в списке</span>
                        <span className={styles.channel_description}>подробнее о способе</span>
                    </div>
                    <button className={styles.channel_button} onClick={methodInfoCallback}>ПОДРОБНЕЕ</button>
                </div>
            </div>}

            {list.map((el, elIndex) => {
                if (mode === "myOrders") {
                    const order = el as MyOrder;
                    return <div className={styles.channel} key={elIndex} onClick={() => handleChannelClick && handleChannelClick(el)}>
                        {getChatPhoto(order.full_name, order.photo_url, (e: any) => {e.stopPropagation(); handleChannelClick && handleChannelClick(el)})}
                        <div className={styles.channel_body} onClick={(e) => {e.stopPropagation(); handleChannelClick && handleChannelClick(el)}}>
                            <div className={styles.channel_data}>
                                <span className={styles.channel_name}><ChannelIcon/>{order.full_name}</span>
                                <span className={`${styles.channel_description} ${loadingDescription ? styles.shimmer : ""}`}>{order.subscribed}/{order.num_sub}</span>
                            </div>
                            {handleChannelButton && <button className={styles.channel_button} onClick={(e) => {e.stopPropagation(); handleChannelButton(el)}}>ПОДРОБНЕЕ</button>}
                        </div>
                    </div>;
                }
                else if (mode === "selectChat") {
                    const chat = el as Chat;
                    return <div className={styles.channel} key={elIndex} onClick={() => handleChannelClick && handleChannelClick()} style={{background: "var(--tg-theme-secondary-bg-color)", borderRadius: "5px", borderBottom: "none"}}>
                        {getChatPhoto(chat.full_name, chat.photo_url, (e: any) => {e.stopPropagation(); handleChannelClick && handleChannelClick()})}
                        <div className={styles.channel_body} onClick={(e) => {e.stopPropagation(); handleChannelClick && handleChannelClick()}}>
                            <div className={styles.channel_data}>
                                <span className={styles.channel_name}><ChannelIcon/>{chat.full_name}</span>
                                <span className={styles.channel_description}>{moment.unix(chat.create_dt).format('HH:mm DD.MM.YY')}</span>
                            </div>
                            <ArrowIcon className={styles.channel_switch}/>
                        </div>
                    </div>;
                }
                else if (mode === "orders") {
                    const order = el as Order;
                    const middlewareHandler = async (order: Order, func: Function) => {
                        if (func) {
                            const result = await func(order);
                            
                            if (!result || result !== -1) {
                                setOpenedOrderID(order.id);
                            };
                        };
                    };
                    return <div className={styles.channel} key={elIndex} onClick={() => middlewareHandler(order, handleChannelClick as Function)}>
                        {getChatPhoto(order.full_name, order.photo_url, (e: any) => {e.stopPropagation(); middlewareHandler(order, handleChannelClick as Function)})}
                        <div className={`${styles.channel_body} ${styles.channel__without_border}`} onClick={(e) => {e.stopPropagation(); middlewareHandler(order, handleChannelClick as Function)}}>
                            <div className={styles.channel_data}>
                                <span className={styles.channel_name}><ChannelIcon/>{order.full_name}</span>
                                <span className={styles.channel_description}>за подписку <span className={styles.reward}>+{order.sub_price} <MoneyIcon/></span></span>
                            </div>
                            {handleChannelButton && <button className={!openedOrderID || openedOrderID !== order.id ? styles.channel_button : styles.channel_button__active} onClick={(e) => {
                                    e.stopPropagation(); 
                                    if (!openedOrderID || openedOrderID !== order.id) {
                                        middlewareHandler(order, handleChannelClick as Function);
                                    } else {
                                        handleChannelButton(order);
                                    };
                                }}
                                style={processButtons.includes(String(order.id)) ? {"color": "transparent"} : {}}
                                disabled={processButtons.includes(String(order.id))}
                            >
                                {!openedOrderID || openedOrderID !== order.id ? "ПОДПИСАТЬСЯ" : "ПРОВЕРИТЬ"}
                                {processButtons.includes(String(order.id)) && <div className={styles.spinner_wrapper}><Spinner/></div>}    
                            </button>}
                        </div>
                    </div>;
                }
                else if (mode === "adminChat") {
                    const chat = el as Chat;
                    return <div className={styles.channel} key={elIndex} onClick={() => (handleChannelClick as Function)(chat)}>
                        {getChatPhoto(chat.full_name, chat.photo_url, (e: any) => {e.stopPropagation(); (handleChannelClick as Function)(chat)})}
                        <div className={`${styles.channel_body} ${styles.channel__without_border}`} onClick={(e) => {e.stopPropagation(); (handleChannelClick as Function)(chat)}}>
                            <div className={styles.channel_data}>
                                <span className={styles.channel_name}><ChannelIcon/>{chat.full_name}</span>
                                <span className={styles.channel_description}>{moment.unix(chat.create_dt).format('HH:mm DD.MM.YY')}</span>
                            </div>
                            {handleChannelButton && <button className={!openedOrderID || openedOrderID !== chat.id ? styles.channel_button : styles.channel_button__active} onClick={(e) => {
                                    e.stopPropagation(); handleChannelButton(chat, chat.is_approved === true ? "decline" : "approve");
                                }}
                                style={{...(processButtons.includes(String(chat.id)) ? {"color": "transparent", "transition": "none"} : {}), "background": chat.is_approved === true ? "var(--tg-theme-destructive-text-color)" : "#17B978"}}
                                disabled={processButtons.includes(String(chat.id))}
                            >
                                {chat.is_approved === true ? "ЗАБАНИТЬ" : "РАЗБАНИТЬ"}
                                {processButtons.includes(String(chat.id)) && <div className={styles.spinner_wrapper}><Spinner/></div>}    
                            </button>}
                        </div>
                    </div>;
                }
                else if (mode === "moderation") {
                    const chat = el as Chat;
                    const handleButtonClick = (type: string) => {
                        handleChannelButton!([chat, ], type);
                    }
                    return <div className={styles.channel} key={elIndex} onClick={() => handleChannelClick!(chat)}>
                        {getChatPhoto(chat.full_name, chat.photo_url, (e: any) => {e.stopPropagation(); handleChannelClick!(chat)})}
                        <div className={`${styles.channel_body} ${styles.channel__without_border}`} onClick={(e) => {e.stopPropagation(); handleChannelClick!(chat)}}>
                            <div className={styles.channel_data}>
                                <span className={styles.channel_name}><ChannelIcon/>{chat.full_name}</span>
                                <span className={styles.channel_description}>{moment.unix(chat.create_dt).format('HH:mm DD.MM.YY')}</span>
                            </div>
                            {handleChannelButton && <div className={styles.moder_buttons}>
                                {chat.is_approved !== true && <button 
                                        className={`${styles.channel_button} ${styles.moder_button__approve}`} 
                                        onClick={(e) => {e.stopPropagation(); handleButtonClick('approve')}}
                                        disabled={processButtons.includes(`${chat.id}|approve`)}
                                    >
                                        {processButtons.includes(`${chat.id}|approve`) ? <div className={styles.spinner_wrapper}><Spinner/></div> : <ApproveIcon/>}    
                                </button>}
                                {chat.is_approved !== false && <button 
                                        className={`${styles.channel_button} ${styles.moder_button__decline}`} 
                                        onClick={(e) => {e.stopPropagation(); handleButtonClick('decline')}}
                                        disabled={processButtons.includes(`${chat.id}|decline`)}
                                    >
                                        {processButtons.includes(`${chat.id}|decline`) ? <div className={styles.spinner_wrapper}><Spinner/></div> : <DeclineIcon/>}    
                                </button>}
                            </div>}
                        </div>
                    </div>;
                }
                else if (mode === "chats") {
                    const chat = el as Chat;
                    return <div className={styles.channel} key={elIndex} onClick={() => handleChannelClick && handleChannelClick()}>
                        {getChatPhoto(chat.full_name, chat.photo_url, (e: any) => {e.stopPropagation(); handleChannelClick && handleChannelClick()})}
                        <div className={styles.channel_body} onClick={(e) => {e.stopPropagation(); handleChannelClick && handleChannelClick()}}>
                            <div className={styles.channel_data}>
                                <span className={styles.channel_name}><ChannelIcon/>{chat.full_name}</span>
                                {chat.is_approved === true && <span className={`${styles.channel_description} ${loadingDescription ? styles.shimmer : ""}`} style={{color: "var(--tg-theme-accent-text-color)"}}>Проверен</span>}
                                {chat.is_approved === false && <span className={`${styles.channel_description} ${loadingDescription ? styles.shimmer : ""}`} style={{color: "var(--tg-theme-destructive-text-color)"}}>Отклонен</span>}
                                {chat.is_approved === null && <span className={`${styles.channel_description} ${loadingDescription ? styles.shimmer : ""}`}>На проверке</span>}
                            </div>
                        </div>
                    </div>;
                }
                else if (mode === "selectChatList") {
                    const chat = el as Chat;
                    return <div className={styles.channel} key={elIndex} onClick={() => handleChannelClick && handleChannelClick(el)}>
                        {getChatPhoto(chat.full_name, chat.photo_url, (e: any) => {e.stopPropagation(); handleChannelClick && handleChannelClick(el)})}
                        <div className={styles.channel_body} onClick={(e) => {e.stopPropagation(); handleChannelClick && handleChannelClick(el)}}>
                            <div className={styles.channel_data}>
                                <span className={styles.channel_name}><ChannelIcon/>{chat.full_name}</span>
                                <span className={styles.channel_description}>{moment.unix(chat.create_dt).format('HH:mm DD.MM.YY')}</span>
                            </div>
                            {handleChannelButton && <button className={styles.channel_button} onClick={(e) => {e.stopPropagation(); handleChannelButton(el)}}>ВЫБРАТЬ</button>}
                        </div>
                    </div>;
                };
            })}

            {loading && <div className={styles.loading_chats_spinner}><Spinner/></div>}

            {nullMessage && list.length === 0 && <span className={styles.null_message}>{nullMessage}</span>}
            
            {/* {bottomButton && bottomButtonCallback && <button className={styles.bottom_button} onClick={() => bottomButtonCallback()} style={paddingBottom === false ? {bottom: "calc(20px + var(--tg-safe-area-inset-bottom))"} : {}}>{bottomButton}</button>} */}
        </div>
        {bottomButtons && <div className={styles.bottom_buttons}>
            {Object.entries(bottomButtons).map(([buttonText, buttonHandler]) => {
                return <button onClick={buttonHandler}>{buttonText}</button>
            })}
        </div>}
    </div>;
};